export interface INewbuildingCallbackWidgetMicrofrontendAPI {
  '/v1/open': (parameters: IOpenWidgetParams) => Promise<void>;
  '/v1/open-mobile': (parameters: IOpenMobileWidgetParams) => Promise<void>;
}

export interface IOpenWidgetParams {
  /**
   * Параметры для отслеживания аналитики.
   */
  trackingParams: ICallbackWidgetTrackingParams;
  /** Телефон агента */
  agentPhone: string;
  /** Смещение времени для часового пояса, в который совершается звонок (по умолчанию равен часовому поясу пользователя) */
  timezoneOffset?: number | null;
  /** Тема виджета (обычный, ПИК) */
  theme?: TCallbackWidgetTheme;
  /** Номер телефона по умолчанию, на который должны перезвонить */
  userPhoneNumber?: string | null;
  /** Идентификатор пользователя (для загрузки времени работы) **/
  builderRealtyUserId: number;
  /** Тип вызывающего сервиса (например КпН) **/
  clientType?: string;
  /** Идентификатор ЖК **/
  newbuildingId: number | null;
  /** Текстовка кнопки заказа звонка. По умолчанию "Перезвоните мне". */
  callbackButtonText?: string;
}

export type TCallbackWidgetTheme = 'default' | 'pik' | 'fsk';

export interface IOpenWidgetWithRecommendationsParams extends IOpenWidgetParams {
  /** Состояние тоггла рекомендаций по умолчанию */
  defaultRecommendationsEnabled?: boolean;
  /** Обработчик переключения тоггла рекомендаций */
  onRecommendationsChange?(status: boolean): void;
  /** Рекомендации для отображения */
  recommendations?: TRecommendation[] | null;
  /** Время между рекомендациями в минутах */
  recommendationTime?: number;
  /** Название ЖК, в котором запрашивается обратный звонок */
  newbuildingName?: string | null;
}

export interface IOpenMobileWidgetParams extends IOpenWidgetParams {
  /** Состояние тоггла рекомендаций по умолчанию */
  defaultRecommendationsEnabled?: boolean;
  /** Обработчик переключения тоггла рекомендаций */
  onRecommendationsChange?(status: boolean): void;
  /** Рекомендации для отображения */
  recommendations?: INewbuildingRecommendationMobile[] | null;
  /** Время между рекомендациями в минутах */
  recommendationTime?: number;
}

export type TOpenWidgetParams = IOpenWidgetParams | IOpenWidgetWithRecommendationsParams;

export type TOpenWidgetResultHandler = (result: IOpenWidgetResult) => void;

interface IOpenWidgetResult {
  isError: boolean;
}

export interface ICallbackWidgetTrackingParams {
  category: string;
  user: Partial<{
    userId: number;
    extra: Record<string, unknown>;
  }>;
  gaLabel: string;
  opener: TRequestCallbackOpener;
}

export type TRequestCallbackOpener = 'blockJK' | 'blockStickytop' | '3dtour' | 'airphoto';

export interface INewbuildingRecommendationMobile {
  address: string;
  agentPhone: string;
  description: string;
  formattedPrice: string;
  id: number;
  newbuildingName: string;
  photoUrl: string;
  underground?: IUnderground | null;
  url: string;
}

export enum ETransportType {
  Transport = 'transport',
  Walk = 'walk',
}

export interface IUnderground {
  color: string;
  name: string;
  time?: string | null;
  transportType?: ETransportType | null;
}

export type TRecommendation = IOfferRecommendation | INewbuildingRecommendation;

export type TRecommendationType = 'offer' | 'newbuilding';
export interface IOfferRecommendation {
  agentPhone: string;
  formattedPrice: string;
  newbuildingName: string;
  photoUrl?: string | null;
  realtyId: number;
  title: string;
  type: 'offer';
  underground?: IUnderground | null;
  url: string;
}

export enum EAgentType {
  Builder = 'builder',
  Seller = 'seller',
}

export interface INewbuildingRecommendation {
  agentLabel?: string | null;
  agentName: string;
  agentPhone: string;
  agentType: EAgentType;
  address?: string;
  buildingStatusInfo: string;
  formattedPrice: string;
  newbuildingId: number;
  newbuildingName: string;
  photoUrl?: string | null;
  type: 'newbuilding';
  underground?: IUnderground | null;
  url: string;
}
